import { useEffect, useState } from "react";
import request from "helper/request";

export const ROUTE_JOB_KIND = {
  OPTIMIZING: "optimizing",
  UPDATING: "updating"
};

const POLL_INTERVAL_MS = 2000;
// Give up eventually so a lost callback doesn't poll forever; the engine answers well within this.
const MAX_POLL_MS = 15 * 60 * 1000;

/**
 * Polls the backend for the routing-engine result of a draft while `enabled`.
 * Returns `{ event, payload }` once the backend has stored it, `null` until then.
 */
export function useRouteJobResult(kind, draftId, enabled = true) {
  const [result, setResult] = useState(null);

  useEffect(() => {
    setResult(null);
    if (!enabled || !draftId) return;

    let cancelled = false;
    let timer;
    const startedAt = Date.now();

    const poll = async () => {
      try {
        const res = await request.get(`/route-job-results/${kind}/${draftId}`);
        if (cancelled) return;
        if (res?.result) {
          setResult(res.result);
          return;
        }
      } catch (err) {
        if (cancelled) return;
        console.error("[route-job-result] poll failed", err);
      }
      if (Date.now() - startedAt < MAX_POLL_MS) {
        timer = setTimeout(poll, POLL_INTERVAL_MS);
      }
    };
    poll();

    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [kind, draftId, enabled]);

  return result;
}
